import React from 'react';
import { useTranslation } from 'react-i18next';

function LegalSection({ tKey, extraNodes }) {
  const { t } = useTranslation();
  const sections = t(`pages.${tKey}.sections`, { returnObjects: true });
  return (
    <section className="auro-legal">
      <div className="auro-container auro-legal__container">
        <header className="auro-legal__head">
          <span className="auro-eyebrow">Auronixio S.r.l.</span>
          <h1 className="auro-h1 auro-h1--legal">{t(`pages.${tKey}.title`)}</h1>
          <p className="auro-legal__updated">{t(`pages.${tKey}.updated`)}</p>
          <p className="auro-legal__intro">{t(`pages.${tKey}.intro`)}</p>
        </header>
        <div className="auro-legal__body">
          {Object.entries(sections).map(([k, s]) => (
            <article key={k}>
              <h2>{s.title}</h2>
              <p>{s.body}</p>
            </article>
          ))}
          {extraNodes}
        </div>
      </div>
    </section>
  );
}

export function PrivacyPage() {
  return <LegalSection tKey="privacy" />;
}

export function TermsPage() {
  return <LegalSection tKey="terms" />;
}

export function CookiesPage() {
  const { t } = useTranslation();
  const openPrefs = () => window.dispatchEvent(new CustomEvent('auronixio:open-cookie-preferences'));
  return (
    <LegalSection
      tKey="cookies"
      extraNodes={
        <div className="auro-legal__cta">
          <button type="button" className="auro-btn auro-btn--primary" onClick={openPrefs} data-testid="reopen-cookie-prefs">
            {t('pages.cookies.open')}
          </button>
        </div>
      }
    />
  );
}
